import React from 'react';

import type { UserRole } from '@doger/core/shared/api';

import { useJWT } from '.';

type RoleGuardProps = {
  children: React.ReactNode;
  roles: UserRole[];
  fallback?: React.ReactNode;
};

export const RoleGuard = ({ children, roles, fallback }: RoleGuardProps) => {
  const jwtPayload = useJWT();

  if (!jwtPayload) {
    return fallback;
  }

  const hasRequiredRole = roles.includes(jwtPayload.role as UserRole);

  if (!hasRequiredRole) {
    return fallback;
  }

  return <>{children}</>;
};
